document.addEventListener('DOMContentLoaded', function () {



	const statsThumbsSlider = new Swiper('.js_stats_thumbslider', {
		slidesPerView: 1,
		spaceBetween: 0,
		resistanceRatio: 0,
		loop: true,

		effect: 'fade',
		fadeEffect: {
			// crossFade: true
		},

		// Disable all user interactions with the thumbs slider
		allowTouchMove: false,
		simulateTouch: false,
		keyboard: false,
		mousewheel: false,

	});


	const statsSlider = new Swiper('.js_stats_slider', {
		slidesPerView: 2,
		spaceBetween: 0,
		resistanceRatio: 0,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		loop: true,
		thumbs: {
			swiper: statsThumbsSlider
		},
		autoplay: {
			delay: 4000,
		},
		watchSlidesProgress: true,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},


	});

});